import { useState } from "react";
import { Send } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { QuestionHead, QuizStudent, Totals } from "@/modes/quiz/QuizStudent";

const Answer = ({ state, send, remaining }) => {
  const [text, setText] = useState("");
  const sent = state.my_answer;
  return (
    <div className="space-y-5" data-testid="student-written">
      <QuestionHead state={state} q={state.question} remaining={remaining} />
      {sent ? <p className="text-center text-[#6EE7B7] font-bold" data-testid="answer-received">Yanıtın alındı: {sent}</p> : (
        <form onSubmit={(e) => { e.preventDefault(); if (text.trim()) send({ type: "answer", text }); }} className="flex gap-2">
          <Input value={text} onChange={(e) => setText(e.target.value)} maxLength={60} disabled={remaining <= 0} placeholder="Cevabını yaz…"
            className="h-14 text-lg" data-testid="written-input" autoComplete="off" />
          <Button type="submit" disabled={!text.trim() || remaining <= 0} className="h-14 px-5" data-testid="written-send" aria-label="Gönder"><Send className="h-5 w-5" /></Button>
        </form>
      )}
      <p className="text-sm text-slate-400">Tek yanıt hakkın var.</p>
    </div>
  );
};

const Result = ({ state }) => {
  const r = state.results;
  if (r.skipped) return <p className="font-display text-2xl font-bold" data-testid="student-skipped">Bu soru atlandı.</p>;
  const ok = r.mine?.status === "correct";
  return (
    <div className="space-y-5" data-testid="student-written-result">
      <QuestionHead state={state} q={state.question} />
      <div className={`rounded-xl p-5 border-2 ${ok ? "border-[#34D399] bg-[#34D399]/10" : "border-red-500/70 bg-red-950/30"}`}>
        <p className="font-display text-3xl font-black" data-testid="student-result-status">{ok ? "Doğru!" : r.mine?.status === "wrong" ? "Yanlış" : "Yanıt vermedin"}</p>
        {ok && <p className="text-2xl font-bold text-[#6EE7B7] mt-2" data-testid="student-result-score">+{r.mine.score} puan</p>}
        {r.mine?.text && <p className="mt-2">Senin yanıtın: <b>{r.mine.text}</b></p>}
        <p className="mt-2">Kabul edilen: <b className="text-[#FACC15]">{r.accepted?.join(" / ")}</b></p>
      </div>
      <Totals state={state} />
    </div>
  );
};

export const WrittenStudent = ({ state, send, remaining }) => {
  if (state.phase === "question") return <Answer key={state.q_index} state={state} send={send} remaining={remaining} />;
  if (state.phase === "results") return <Result state={state} />;
  return <QuizStudent state={state} send={send} remaining={remaining} />;
};
